var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M.162 0h7.62v7.619H.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M8.543 0h7.619v7.619H8.543z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M.162 8.382h7.62V16H.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M8.543 8.382h7.619V16H8.543z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "microsoft_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.162 0h16v16h-16z"
  })))));
};
export default SvgMicrosoft;